import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import NotFound from "./pages/error/404";
import { PrivateRoutes } from "./routes/private";
import { AuthRoutes } from "./routes/auth";
import { SuperAdminRoutes } from "./routes/superAdminRoute";
import Signin from "./pages/auth/signin";
import Dashboard from "./pages/dashboard/dashboard";
import Users from "./pages/dashboard/users";
import Orders from "./pages/dashboard/orders";
import OrderPreview from "./pages/dashboard/OrderPreview";
import Products from "./pages/dashboard/products";
import Profile from "./pages/admin/profile"
import NewAdmin from "./pages/admin/new_admin";
import ForgotPassword from "./pages/auth/forgot_password";

function App() {
  return (
    <React.Fragment>
      <BrowserRouter>
        <Routes>
          <Route
            path="/"
            element={<Navigate to="/signin" />}
          />

          <Route
            path="*"
            element={<NotFound />}
          />

          <Route element={<PrivateRoutes />}> 
            <Route 
              element={<Dashboard />} 
              path='/dashboard' 
            />

            <Route
              element={<Users />}
              path='/users'
            />

            <Route
              element={<Orders />}
              path='/orders'
            />

            <Route
              element={<OrderPreview />}
              path='/orders/:id'
            />

            <Route
              element={<Products />}
              path='/products'
            />

            <Route
              element={<Profile />}
              path='/profile'
            />
          </Route> 

          <Route element={<SuperAdminRoutes />}>
            <Route
              element={<NewAdmin />}
              path='/new_admin'
            />
          </Route>

          <Route element={<AuthRoutes />}>
            <Route 
              path="/signin" 
              element={<Signin />} 
            />

            <Route 
              path="/forgot_password" 
              element={<ForgotPassword />} 
            />
          </Route>
        </Routes>
      </BrowserRouter>
    </React.Fragment>
  );
}

export default App;